import YFormTagging from './Tagging';

export { YFormTagging };
export default YFormTagging;
